import React from "react";
import { StandardProductCardList } from "../ProductCard/StandardProductCardList";

export const StandardProductListColumn = () => {
  return (
    <div className="gg-col-span-9 gg-flex gg-flex-col gg-rounded gg-border-y gg-border-r gg-bg-gray-100 gg-px-[1.563rem] gg-pb-5 gg-pt-4 sm:gg-pb-6 lg:gg-col-span-5 xl:gg-pb-5">
      <header className="gg-max-md:flex-wrap gg-flex gg-min-h-fit gg-w-full gg-justify-between gg-pb-2">
        <h1 className="gg-text-xl gg-font-bold gg-leading-8 gg-text-dark-blue sm:gg-text-2xl">
          Maak het af
        </h1>
        <p className="gg-self-end gg-pb-1 gg-text-xs gg-leading-5 gg-text-[#9493A3]">
          Alle prijzen zijn inclusief BTW
        </p>
      </header>

      <StandardProductCardList />

      <footer className="gg-mt-6 gg-flex gg-h-full gg-w-full gg-items-end gg-text-sm gg-leading-6 gg-text-gray-500">
        <span className="gg-text-pretty">
          Accessoires zoals kleurstalen, gereedschap en lijm worden apart als
          pakket verzonden. Je ontvangt een track & trace per mail zodra je
          bestelling klaar is om verzonden te worden.
        </span>
      </footer>
    </div>
  );
};
